<template>
    <div class="panel-body dnum-guided-assistance">
        <h3 class="h2">{{ items['root'].description }}</h3>
        <div class="row row-flex">
            <template v-for="(item, index) in items['root'].options">
                <div class="col-xs-12 col-flex">
                    <a class="btn btn-gray-light btn-lg btn-block no-scroll collapsed" data-level="1" v-bind:data-toggle="collapse(items[item])"
                       v-bind:href="href(items[item], index)" aria-expanded="false" v-bind:target="target(items[item])" v-bind:aria-controls="id(index)"><i
                            class="us us-fw text-primary" v-bind:class="items[item].icon"></i>{{ items[item].title }}</a>
                </div>
                <HelpItem v-bind:items="items" v-bind:item="item" v-bind:index="index" v-bind:level="1"/>
            </template>
        </div>
    </div>
</template>


<script>
    import HelpItem from './components/HelpItem.vue';

    export default {
        name: "help",
        components: {
            HelpItem
        },
        data() {
            return {
                items: {"root":{"description":"loading"}},
                path: null,
                message: "main"
            }
        },
        created: function () {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                var self = this;
                this.$http.get(portal_conf["help"]).then(response => {
                    self.items = response.body;
                }, response => {
                    console.error("Error during retrieving data");
                });

            },
            collapse: function (item) {
                return (item.action == null ? "collapse" : null);
            },
            target: function (item) {
                return (item.action != null ? "_blank" : null);
            },
            id: function (option) {
                return "choix-" + option;
            },
            href: function (item, option) {
                return (item.action != null ? item.action : "#" + this.id(option));
            }
        }
    }
</script>


<style>
    .btn {
        white-space: normal !important;
    }
</style>



// WEBPACK FOOTER //
// src/help/src/help.vue